import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, DeleteGroupDialogueHandler } from '../types';
import DeleteGroupDialogueContext from './DeleteGroupContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type DeleteGroupDialogueProps = {
  handleDialogue: DialogueHandler<DeleteGroupDialogueHandler>;
};

type FC = FunctionComponent<DeleteGroupDialogueProps>;

const DeleteGroupDialogue: FC = ({ handleDialogue }: DeleteGroupDialogueProps) => {
  const { showDeleteGroupErrorAlert, deleteGroupError } = useContext(DeleteGroupDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.DeleteGroupErrorDialog' });

  return useMemo(
    () => (
      <div>
        {/* Delete Group Error */}
        <ConfirmationDialogue
          isVisible={showDeleteGroupErrorAlert}
          title={t('title')}
          status="error"
          subTitle={`${deleteGroupError}`}
          confirm={{
            label: t('confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showDeleteGroupErrorAlert, deleteGroupError],
  );
};

export default DeleteGroupDialogue;
